var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 30c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14zm.057-1.314c7.006 0 12.686-5.68 12.686-12.686S23.063 3.314 16.057 3.314 3.371 8.994 3.371 16c.001 7.006 5.68 12.686 12.687 12.686zM16 27.714c6.47 0 11.714-5.244 11.714-11.714S22.47 4.286 16 4.286 4.286 9.53 4.286 16 9.53 27.714 16 27.714zm.029-1.428c5.695 0 10.313-4.618 10.313-10.315 0-5.695-4.618-10.313-10.314-10.313-5.698 0-10.316 4.618-10.316 10.314 0 5.698 4.618 10.316 10.315 10.316zm-.584-18.648 7.468 12.954.8-1.39-6.666-11.564h-1.602zM8.286 19.18l6.39-11.088.014.023.013-.022 7.573 13.14h-1.601l-1.914-3.32a9.126 9.126 0 0 0-2.754-.423c-.495 0-.978.035-1.448.103l.923-1.597a10.775 10.775 0 0 1 2.25.126l-3.04-5.273-5.604 9.719-.8-1.39zm4.345-.17 2.872-4.981-.8-1.39-4.953 8.592h1.6l.015-.026c1.374-.827 2.95-1.245 4.671-1.245 1.1 0 2.153.195 3.128.55l-1.072-1.857a10.688 10.688 0 0 0-5.461.358z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAca);
export default __webpack_public_path__ + "static/media/ACA.0172f846c4bbc77a81ef2989089d0e29.svg";
export { ForwardRef as ReactComponent };